import { DateCell, FileViewCell, RawTextCell, TooltipCell } from '@/components/Table/components/Cell'
import { Box, Button, Flex } from '@chakra-ui/react'
import { createColumnHelper } from '@tanstack/react-table'
import moment from 'moment'
import React from 'react'
import { AiOutlineCaretDown, AiOutlineCaretRight } from 'react-icons/ai'
import { MdDeleteOutline, MdOutlineCheckCircle } from 'react-icons/md'

const getOfferHistoryTableColumns = ({ handleOpenFileDetail }) => {
  const columnHelper = createColumnHelper()

  return [
    columnHelper.accessor('revision', {
      cell: ({ row, getValue }) => {
        const value = getValue()
        if (!row.getCanExpand()) {
          return <></>
        }
        return (
          <Flex alignItems={'center'} gap={'3'} justifyContent={'center'}>
            <Box onClick={row.getToggleExpandedHandler()} cursor="pointer">
              {row.getIsExpanded() ? <AiOutlineCaretDown /> : <AiOutlineCaretRight />}
            </Box>
            <TooltipCell text={value} />
          </Flex>
        )
      },
    }),
    columnHelper.accessor('position', {}),
    columnHelper.accessor('name', {
      size: 150,
    }),
    columnHelper.accessor('status', {
      size: 300,
    }),
    columnHelper.accessor('date', {
      size: 150,
      cell: ({ row, getValue }) => {
        if (row.getCanExpand()) {
          return <></>
        }
        const date = moment(getValue() ?? null)

        return <TooltipCell text={date.isValid() ? date.format('DD-MMM-YYYY HH:mm:ss') : '(-)'} />
      },
    }),
    columnHelper.accessor('remarks', {
      size: 300,
    }),
    columnHelper.accessor('files', {
      cell: ({ row, getValue }) => {
        if (row.getCanExpand()) {
          return <></>
        }
        const value = getValue()
        if (!Array.isArray(value) || value.length === 0) {
          return <>(-)</>
        }
        return (
          <Button colorScheme="blue" onClick={() => handleOpenFileDetail(value, 'Upload by ')}>
            Files
          </Button>
        )
      },
    }),
  ]
}

export default getOfferHistoryTableColumns
